import { Button } from "@material-ui/core";
import React, { useState } from "react";

const CntbkUploadImg = () => {
  const [img, setImg] = useState([]);
  const handleChange = (e) => {
    console.log([...e.target.files]);
    setImg([...img, ...e.target.files]);
  }
  const img_nodes = img.map(x => x?<img width="250px" src={URL.createObjectURL(x)}/> :null);
  return(
    <div>
      <div>画像アップロードテスト</div>
      {img.length!==0 && (
        <div>
          {img_nodes}
          <Button
            variant="contained"
            onClick={() => setImg([])}
          >
            画像削除
          </Button>
        </div>
      )}
      <label htmlFor="uploadImgButton">
        <input
          hidden
          multiple
          type="file"
          name="image"
          id="uploadImgButton"
          onChange={handleChange}
        />
        <Button
          variant="contained"
          component="span"
        >
          画像追加
        </Button>
      </label>
    </div>
  )
}
export default CntbkUploadImg